import intlMessagesEN from './i18n/localization/en.json';
import intlMessagesVi from './i18n/localization/vi.json';

export default {
  name: 'FormRegisterPublic2',
  dir: 'FormRegisterPublic2',
  pathRoot: '2024',
  routes: [
    {
      url: 'dang-ky/:slug',
      component: 'Page',
      meta: {
        authRoute: true,
      },
      layout: 'BlankLayout',
      props: {
        title: 'Đăng ký sự kiện | Smart Event',
        titleI18n: 'FormRegisterPublic2:title',
      },
    },
  ],
  lang: { vi: intlMessagesVi, en: intlMessagesEN },
  isAuthenticate: 'Any',
};
